import styled from 'styled-components';
import Chip from '@spa/shared/components/Unisystem/Chip';
import { Wrapper as Placeholder } from '@spa/shared/components/Unisystem/Placeholder/styles';
export var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bm5mmu-0"
})(["display:grid;grid-template-columns:3fr repeat(2,1fr);grid-template-rows:repeat(2,221px);gap:", ";height:455px;width:100%;position:relative;", "{cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}}", ";"], function (props) {
  return props.theme.space(3);
}, Placeholder, function (props) {
  return props.isMobile && "\n    display: block;\n    height: calc(100vw * 9 / 16);\n    margin-top: ".concat(props.theme.space(15), ";\n    margin-bottom: ").concat(props.theme.space(3), ";\n  ");
});
export var MainPhoto = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-bm5mmu-1"
})(["width:100%;height:100%;grid-row-start:1;grid-row-end:3;object-fit:cover;border-radius:12px;cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile && 'border-radius: 0';
});
export var Photo = /*#__PURE__*/styled.img.withConfig({
  componentId: "sc-bm5mmu-2"
})(["border-radius:12px;width:100%;height:100%;object-fit:cover;cursor:pointer;transition:filter 0.2s ease-in-out;&:hover{filter:brightness(0.9);}"]);
export var PhotosChip = /*#__PURE__*/styled(Chip).withConfig({
  componentId: "sc-bm5mmu-3"
})(["position:absolute;right:15px;bottom:10px;", ""], function (_ref2) {
  var isGalleryHover = _ref2.isGalleryHover;
  return isGalleryHover && "\n      min-width: 120px;\n  ";
});
export var Fomo = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-bm5mmu-4"
})(["position:absolute;top:", ";display:flex;align-items:center;gap:", ";padding-right:", ";border-radius:0 8px 8px 0;height:40px;z-index:1;background:", ";color:", ";font-size:", ";line-height:", ";span{display:flex;align-items:center;height:26px;padding:", " ", ";border-radius:0 2px 2px 0;background:", ";color:", ";}"], function (props) {
  return props.theme.space(8);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.fomo.hours.background;
}, function (props) {
  return props.theme.fomo.hours.text;
}, function (props) {
  return props.theme.rem(14);
}, function (props) {
  return props.theme.rem(18);
}, function (props) {
  return props.theme.space(1);
}, function (props) {
  return props.theme.space(2);
}, function (props) {
  return props.theme.fomo.views.background;
}, function (props) {
  return props.theme.fomo.views.text;
});